export default function ui_horizontal_line() {
	return <hr />
}
